import {Modal} from 'react-bootstrap'
import Swal from 'sweetalert2'
import {useState} from 'react'
import {MutationPutCorretores, QueryGetCorretoresByID} from '../../../../../graphql'
import {FormInputAndLabel} from '../../../../../components/UI/Inputs/FormInputAndLabel'
import {FormInputMaskAndLabel} from '../../../../../components/UI/Inputs/FormInputMaskAndLabel'
import {Loader} from '../../../../../components/UI/Loader/Loader'
import {KTSVG} from '../../../../../../_metronic/helpers'

interface Props {
  id: number
}

export function EditFormCorretor({id}: Props) {
  const [showEdit, setShowEdit] = useState(false)
  const {data} = QueryGetCorretoresByID({
    variables: {getCorretorByIdId: id},
  })

  const {FormCorretor, loading, handleSubmit, register, errors} = MutationPutCorretores()

  const onSubmit = async (data) => {
    FormCorretor(data)
      .then((result) => {
        Swal.fire('Sucesso!', 'Dados atualizados com sucesso.', 'success')
        setShowEdit(false)
      })
      .catch((error) => {
        Swal.fire('Erro!', 'Ocorreu um erro durante o processo.', 'error')
      })
  }

  // useEffect(() => {
  //   if (show) {
  //     if (error) {
  //       Swal.fire('Erro!', 'Ocorreu um erro durante o processo.', 'warning')
  //     } else if (DataSetCorretor) {

  //       setShowEdit(false)
  //       Swal.fire('Sucesso!', 'Informações atualizadas com sucesso.', 'success')
  //     }
  //   }
  // }, [DataSetCorretor, closeModal, error, id, show])

  // Tratativa de loading
  if (loading) {
    Swal.fire('Enviando Informações...', '')
    Swal.showLoading()
  }

  if (!data) {
    return (
      <>
        <Modal centered animation show={showEdit} onHide={() => setShowEdit(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Editar Corretor</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Loader text='Carregando Informações...' />
          </Modal.Body>
        </Modal>
      </>
    )
  }

  return (
    <>
      <button
        onClick={(e) => {
          // OpenModalEdit(Response.corretor.id)
          setShowEdit(true)
        }}
        className='btn btn-icon btn-light-success btn-sm me-2'
      >
        <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' />
      </button>

      <Modal centered animation show={showEdit} onHide={() => setShowEdit(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Editar Corretor</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit(onSubmit)}>
            <input
              className='form-control form-control-solid'
              type='number'
              hidden={true}
              defaultValue={data ? data.GetCorretorById.id : ''}
              {...register('id', {required: true})}
            />
            <div className='row'>
              <div className='col-md-12'>
                <div className='mb-6'>
                  <FormInputAndLabel
                    label='Nome Completo'
                    className='form-control required form-control-solid'
                    placeholder='Nome Completo'
                    defaultValue={data ? data.GetCorretorById.nome : ''}
                    register={register('nome')}
                    error={errors ? errors.nome?.message : ''}
                  />
                </div>
              </div>

              <div className='col-md-12'>
                <div className='mb-6'>
                  <FormInputAndLabel
                    label='Email'
                    className='form-control required form-control-solid'
                    placeholder='Ex: joao@email.com'
                    defaultValue={data ? data.GetCorretorById.email : ''}
                    register={register('email')}
                    error={errors ? errors.email?.message : ''}
                  />
                </div>
              </div>

              <div className='col-md-12'>
                <div className='mb-6'>
                  <FormInputMaskAndLabel
                    label='Telefone:'
                    maskChar=' '
                    mask='(99) 99999-9999'
                    className='form-control form-control-solid'
                    placeholder='Ex: (00) 00000-0000'
                    defaultValue={data ? data.GetCorretorById.telefone : ''}
                    register={register('telefone')}
                    error={errors ? errors.telefone?.message : ''}
                  />
                </div>
              </div>

              <div className='col-md-12'>
                <div className='mb-6'>
                  <FormInputAndLabel
                    label='Empresa'
                    className='form-control required form-control-solid'
                    placeholder='Empresa'
                    defaultValue={data ? data.GetCorretorById.empresa : ''}
                    register={register('empresa')}
                    error={errors ? errors.empresa?.message : ''}
                  />
                </div>
              </div>

              <div className='col-md-12 py-6 d-flex' style={{justifyContent: 'flex-end'}}>
                <button
                  className='btn btnSecondary  pull-right '
                  type='button'
                  onClick={() => setShowEdit(false)}
                >
                  Fechar
                </button>
                <button disabled={loading} type='submit' className='btn btn-success mx-2'>
                  Salvar
                </button>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  )
}
